import React, { FC, useCallback } from "react";

import { usePlayerStore } from "../../store/usePlayerStore";
import { BackgroundVideoPlayButton } from "../PlayButton/BackgroundVideoPlayButton";

import { OverlayControls } from "./OverlayControls";

export const PlayerUIBackgroundVideo: FC = () => {
  const { getState } = usePlayerStore();

  const togglePlayback = useCallback(() => {
    if (getState().isPaused) {
      getState().player.play();
    } else {
      getState().player.pause();
    }
  }, [getState]);

  const onKeyUp = useCallback(
    (event: React.KeyboardEvent) => {
      const key = event.key.toLowerCase();
      if (key === "k") {
        togglePlayback();
      }
    },
    [togglePlayback]
  );

  const overlayControlsClick = useCallback(
    () =>
      getState().isPaused
        ? getState().player.play()
        : getState().player.pause(),
    [getState]
  );

  return (
    <div onKeyUp={onKeyUp}>
      <BackgroundVideoPlayButton />
      <OverlayControls onClick={overlayControlsClick} />
    </div>
  );
};
